/** Shared design tokens for all blueprint-style annotated diagrams. */
export const DT = {
  bg:       '#0D1B2A',   // navy blueprint background
  grid:     '#162436',   // subtle grid lines
  stroke:   '#DDEEFF',   // duct/room outlines (blueprint white-blue)
  fill:     '#142030',   // interior fill of shapes
  leader:   '#7AAABB',   // leader lines
  dot:      '#7AAABB',   // leader endpoint dot
  varColor: '#FF6B1A',   // variable name highlight (hi-vis orange)
  desc:     '#A8B0B6',   // description / label text
  formula:  '#E6E8EA',   // formula line
  dim:      '#4A6070',   // dimension lines / ticks
  arrow:    '#DDEEFF',   // flow arrows
  mono:     'JetBrains Mono' as const,
  sans:     'Inter' as const,
  /** Standard viewBox for all diagrams — fits 390px phone with 20px padding each side */
  viewBox:  '0 0 350 260' as const,
  vw:       350,
  vh:       260,
};
